export default __webpack_public_path__ + "static/media/phone-icon.e8c8472c.svg";